import { GlobalStyles as GlobalThemeStyles } from "@mui/material";
import React from "react";
export const defaultFontSize = 16;
export const GlobalStyles = () => {
  return (
    <GlobalThemeStyles
      styles={{
        "*": {
          margin: 0,
          padding: 0,
          boxSizing: "border-box",
          color: "000",
        },
        html: {
          width: "100%",
          height: "100%",
          overflow: "hidden",
        },
        body: {
          width: "100%",
          height: "100%",
        },
        "#root": {
          width: "100%",
          height: "100%",
        },
      }}
    />
  );
};
